import { FC, HTMLProps } from 'react';

export const ColorIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="4" fill="currentColor" />
      <g opacity="0.7">
        <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="currentColor" />
      </g>
    </svg>
  );
};
